import type { PropsWithChildren } from 'react'

export function Footer({ children, className }: PropsWithChildren<{ className?: string }>) {
  return <div className={className}>{children}</div>
}
